import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { ICON_COLORS } from 'Style/colors';

import Icon from '../icon';

export const StyledCommentIcon = styled(Icon)({
  color: ICON_COLORS.emphasis,
});

function CommentIcon({ size, ...props }) {
  return (
    <StyledCommentIcon
      name="comment"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      {...props}
      renderComponent={() => (
        <>
          <path
            d="M10.0003 9.16699C10.4606 9.16699 10.8337 8.7939 10.8337 8.33366C10.8337 7.87342 10.4606 7.50033 10.0003 7.50033C9.54009 7.50033 9.16699 7.87342 9.16699 8.33366C9.16699 8.7939 9.54009 9.16699 10.0003 9.16699Z"
            fill="currentColor"
          />
          <path
            d="M14.167 8.33366C14.167 8.7939 13.7939 9.16699 13.3337 9.16699C12.8734 9.16699 12.5003 8.7939 12.5003 8.33366C12.5003 7.87342 12.8734 7.50033 13.3337 7.50033C13.7939 7.50033 14.167 7.87342 14.167 8.33366Z"
            fill="currentColor"
          />
          <path
            d="M6.66699 9.16699C7.12723 9.16699 7.50033 8.7939 7.50033 8.33366C7.50033 7.87342 7.12723 7.50033 6.66699 7.50033C6.20676 7.50033 5.83366 7.87342 5.83366 8.33366C5.83366 8.7939 6.20676 9.16699 6.66699 9.16699Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.2027 1.66699H7.79799C6.89483 1.66698 6.16637 1.66698 5.57647 1.71517C4.9691 1.7648 4.43561 1.86964 3.94203 2.12113C3.15802 2.5206 2.5206 3.15802 2.12113 3.94203C1.86964 4.43561 1.7648 4.9691 1.71517 5.57647C1.66698 6.16637 1.66698 6.89483 1.66699 7.79799V8.86933C1.66698 9.77249 1.66698 10.5009 1.71517 11.0908C1.7648 11.6982 1.86964 12.2317 2.12113 12.7253C2.5206 13.5093 3.15802 14.1467 3.94203 14.5462C4.4895 14.8251 5.10327 14.929 5.83366 14.9703V18.3337C5.83366 18.6707 6.03669 18.9746 6.34809 19.1036C6.65949 19.2325 7.01792 19.1612 7.25625 18.9229L11.1788 15.0003H12.2026C13.1058 15.0003 13.8343 15.0003 14.4242 14.9521C15.0316 14.9025 15.565 14.7977 16.0586 14.5462C16.8426 14.1467 17.48 13.5093 17.8795 12.7253C18.131 12.2317 18.2359 11.6982 18.2855 11.0908C18.3337 10.501 18.3337 9.77254 18.3337 8.86944V7.79797C18.3337 6.89486 18.3337 6.16635 18.2855 5.57647C18.2359 4.9691 18.131 4.43561 17.8795 3.94203C17.48 3.15802 16.8426 2.5206 16.0586 2.12113C15.565 1.86964 15.0316 1.7648 14.4242 1.71517C13.8343 1.66698 13.1058 1.66698 12.2027 1.66699ZM4.69868 3.60614C4.91815 3.49432 5.20789 3.41751 5.71219 3.37631C6.22623 3.33431 6.88649 3.33366 7.83366 3.33366H12.167C13.1142 3.33366 13.7744 3.33431 14.2885 3.37631C14.7928 3.41751 15.0825 3.49432 15.302 3.60614C15.7724 3.84583 16.1548 4.22828 16.3945 4.69868C16.5063 4.91815 16.5831 5.20789 16.6243 5.71219C16.6663 6.22623 16.667 6.88649 16.667 7.83366V8.83366C16.667 9.78083 16.6663 10.4411 16.6243 10.9551C16.5831 11.4594 16.5063 11.7492 16.3945 11.9686C16.1548 12.439 15.7724 12.8215 15.302 13.0612C15.0825 13.173 14.7928 13.2498 14.2885 13.291C13.7744 13.333 13.1142 13.3337 12.167 13.3337H10.8337C10.6126 13.3337 10.4007 13.4215 10.2444 13.5777L7.50033 16.3218V14.1623C7.50033 13.7065 7.13408 13.3353 6.67828 13.3291C5.53752 13.3136 5.04961 13.24 4.69868 13.0612C4.22828 12.8215 3.84583 12.439 3.60614 11.9686C3.49432 11.7492 3.41751 11.4594 3.37631 10.9551C3.33431 10.4411 3.33366 9.78083 3.33366 8.83366V7.83366C3.33366 6.88649 3.33431 6.22623 3.37631 5.71219C3.41751 5.20789 3.49432 4.91815 3.60614 4.69868C3.84583 4.22828 4.22828 3.84583 4.69868 3.60614Z"
            fill="currentColor"
          />
        </>
      )}
    />
  );
}

CommentIcon.propTypes = {
  size: PropTypes.number,
};

CommentIcon.defaultProps = {
  size: 20,
};

export default CommentIcon;
